import { MessageCircle, Bug, Sparkles } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu'
import { captureEvent } from '@/lib/analytics'

// Each menu item fires a PostHog event. The matching PostHog survey is
// configured with "When an event is captured" → these event names, so PostHog
// auto-renders the popover when the event fires. Cadence is whatever the
// surveys are set to (likely "Every month" for least restriction).
export function FeedbackButton() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Send feedback"
          title="Send feedback"
          className="fixed bottom-5 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-border bg-card text-muted-foreground shadow-lg shadow-black/20 transition-all hover:scale-105 hover:border-primary/40 hover:text-foreground active:scale-95"
        >
          <MessageCircle className="h-5 w-5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" align="end" sideOffset={8} className="w-52">
        <DropdownMenuItem onSelect={() => captureEvent('feature_request_button_click')}>
          <Sparkles className="h-4 w-4 text-primary" />
          Request a feature
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => captureEvent('bug_report_button_click')}>
          <Bug className="h-4 w-4 text-amber-400" />
          Report a bug
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
